import { TUTORIAL_IDS } from "@/shared";

import { STEP_GROUP, TUTORIAL_BUTTON_TYPE } from "../../types";
import useTutorialMode from "../useTutorialMode";

const useCreateScheduleActions = (
  isVehiclesPage: boolean,
  handleTutorialCompletion: (stepGroup: STEP_GROUP) => Promise<void>
) => {
  const { stepIndex, handleTutorialStepIndexChange, setIsMobileDrawerOpen } =
    useTutorialMode();

  const handleDesktopPreviousButton = () => {
    switch (stepIndex) {
      case 2:
        return isVehiclesPage && handleTutorialStepIndexChange(stepIndex - 2);
      case 3:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        return handleTutorialStepIndexChange(stepIndex - 1);
      case 5:
        document.getElementById(TUTORIAL_IDS.SchedulesDialogButton)?.click();
        return handleTutorialStepIndexChange(stepIndex - 1);
      default:
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
    }
  };

  const handleDesktopNextButton = () => {
    const nextStepIndex = isVehiclesPage ? 2 : 1;
    switch (stepIndex) {
      case 0:
        return handleTutorialStepIndexChange(stepIndex + nextStepIndex);
      case 4:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        return handleTutorialStepIndexChange(stepIndex + 1);
      case 5:
        handleTutorialCompletion(STEP_GROUP.TutorialCreateSchedule);
        break;
      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  const handleMobilePreviousButton = () => {
    switch (stepIndex) {
      case 2:
        setIsMobileDrawerOpen(false);
        return handleTutorialStepIndexChange(stepIndex - 1);
      case 3:
        return handleTutorialStepIndexChange(stepIndex - 3);
      case 4:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        return handleTutorialStepIndexChange(stepIndex - 1);
      case 6:
        document.getElementById(TUTORIAL_IDS.SchedulesDialogButton)?.click();
        return handleTutorialStepIndexChange(stepIndex - 1);
      default:
        handleTutorialStepIndexChange(stepIndex - 1);
        break;
    }
  };

  const handleMobileNextButton = () => {
    const nextStepIndex = isVehiclesPage ? 3 : 1;
    switch (stepIndex) {
      case 0:
        return handleTutorialStepIndexChange(stepIndex + nextStepIndex);
      case 5:
        document
          .getElementById(TUTORIAL_IDS.SchedulesMainDialogCloseButton)
          ?.click();
        return handleTutorialStepIndexChange(stepIndex + 1);
      case 6:
        return handleTutorialCompletion(STEP_GROUP.TutorialCreateSchedule);
      default:
        handleTutorialStepIndexChange(stepIndex + 1);
        break;
    }
  };

  const createScheduleDesktopButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handleDesktopPreviousButton()
      : handleDesktopNextButton();
  };

  const createScheduleMobileButtonActions = (
    buttonType: TUTORIAL_BUTTON_TYPE
  ) => {
    buttonType === TUTORIAL_BUTTON_TYPE.Previous
      ? handleMobilePreviousButton()
      : handleMobileNextButton();
  };

  return {
    createScheduleDesktopButtonActions,
    createScheduleMobileButtonActions
  };
};

export default useCreateScheduleActions;
